/**
 * Browser-chrome frame wrapping the stage's demo preview — target look
 * only, not a functional browser.
 *
 * The Alerts page builder's browser mockup
 * (pages/AlertPage/BrowserWindowMockup.js) was reviewed first, per the
 * handoff's instruction to reuse it before building anything new. It isn't
 * reusable here: it's `position:absolute` with hardcoded `calc(100vh -
 * 290px)` heights (tuned to the Alerts page's own layout, not this card's),
 * raw hex colours instead of tokens, red/yellow/green macOS-style dots, and
 * an editable `<input>` address bar — none of which match this spec's
 * static locked address pill on neutral gray-300 dots, or its
 * width-animates-on-mobile behaviour. Built new instead, matching the
 * prototype's structure/values directly.
 * Spec: assets/handoffs/design_handoff_new_calendar_page/FIXES-demo-preview.md §8-9
 *
 * @param {string} address - display-only address text, e.g. "demo.revisual.io/detailed-list"
 * @param {boolean=false} mobile - narrows the frame to 390px and hides the dots
 * @param {ReactNode} children
 */
import React from "react";
import classNames from "classnames";
import Icon from "../../theme/untitled/icons/Icon";
import styles from "./DemoBrowserFrame.module.scss";

const DemoBrowserFrame = ({ address, mobile = false, children }) => {
  return (
    <div className={classNames(styles.frame, { [styles["frame--mobile"]]: mobile })}>
      <div className={styles.bar}>
        {!mobile && (
          <span className={styles.dots}>
            <i />
            <i />
            <i />
          </span>
        )}
        <span className={styles.address}>
          <Icon name="Lock01" size={12} className={styles.addressIcon} />
          {address}
        </span>
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
};

export default DemoBrowserFrame;
